var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card-text',{staticClass:"pa-0",style:(`height: ${_vm.height}px; overflow: auto`)},[_c('a-table-f-sql',{ref:"tableBalance",attrs:{"query":_vm.sqlBalance,"footer":_vm.sqlBalance.footer,"model":_vm.balanceModel,"searchable":false}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }